import * as React from 'react';
import { Box, Button } from 'native-base';
import * as AppActions from '../../redux/actions/appAction';
import * as UserActions from '../../redux/actions/userAction';
import { useDispatch, useSelector } from 'react-redux';
import { buttonStyle } from 'src/styles/buttonStyle';
import { containerStyle } from 'src/styles/containerStyle';
import ProgressBar from 'src/components/ProgressBar';
import { IStore } from 'src/redux/reducers';
import { stackHomeScreen, defaultStackForGroup } from 'src/stack/screens';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { getText } from 'src/utils/i18n';

export default function ChooseLoginTypePage({ navigation }) {

    const currentStack = useSelector((store: IStore) => store.app.currentStack);
    
    const isFetchingUserProfile = useSelector((store: IStore) => store.user.userProfile.isFetching);

    const userProfile = useSelector((store: IStore) => store.user.userProfile.response);

    const dispatch = useDispatch();

    React.useEffect(() => {
        if(userProfile === undefined) {
            dispatch(UserActions.getUserProfile.request())
            return
        }

        initStackOptions()

    }, [userProfile]);

    const initStackOptions = async () => {
        // Check if this is a new signup - if so, don't navigate (initialRouteName handles it)
        if (Platform.OS === 'web') {
            const isNewSignupFlag = await AsyncStorage.getItem('isNewSignup');
            if (isNewSignupFlag === 'true') {
                return; // Don't navigate, let the stack's initialRouteName handle routing
            }
        }

        if (userProfile?.groups.length == 1) {
            await setStack(userProfile?.groups[0])
            return
        }

        if (currentStack !== 'stackChooser') {
            const nextScreen = stackHomeScreen(currentStack)
            navigation.navigate(nextScreen)
            return
        }
    }

    const setStack = async (groupName: string) => {
        const stack = defaultStackForGroup(groupName)
        if (stack === currentStack) {
            const nextScreen = stackHomeScreen(stack)
            navigation.navigate(nextScreen)
            return
        }
        dispatch(AppActions.setCurrentStack(stack))

        if (currentStack === 'stackChooser') {
            const nextScreen = stackHomeScreen(stack)
            navigation.navigate(nextScreen)
        }
    }

    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <ProgressBar isVisible={isFetchingUserProfile} progressText={getText('loadingExperience')} />
            {
                !isFetchingUserProfile &&
                userProfile?.groups.map((groupName, index) => {
                    return (
                        <Button key={index} style={buttonStyle.primaryButton} onPress={() => setStack(groupName)}>
                            {groupName}
                        </Button>
                    )
                })
            }
        </Box>
    );
}